import {
    MARK_AS_RMA_REQUEST,
    MARK_AS_RMA_RESULT,
    MARK_AS_RMA_OPEN_MODAL,
    MARK_AS_RMA_CLOSE_MODAL,
    MARK_AS_RMA_GET_DEVICE_REQUEST,
    MARK_AS_RMA_GET_DEVICE_RESULT,
    MARK_AS_RMA_SET_DEVICE,
} from 'Redux/actionTypes';

export const markAsRmaRequest = (data) => ({
    type: MARK_AS_RMA_REQUEST,
    payload: data
})

export const markAsRmaResult = (result) => ({
    type: MARK_AS_RMA_RESULT,
    payload: result
})

export const markAsRmaOpenModal = (items) => ({
    type: MARK_AS_RMA_OPEN_MODAL,
    payload: items
})

export const markAsRmaCloseModal = () => ({
    type: MARK_AS_RMA_CLOSE_MODAL
})

export const markAsRmaGetDeviceRequest = (item) => ({
    type: MARK_AS_RMA_GET_DEVICE_REQUEST,
    payload: item
})

export const markAsRmaGetDeviceResult = (result) => ({
    type: MARK_AS_RMA_GET_DEVICE_RESULT,
    payload: result
})

export const markAsRmaSetDevice = (device) => ({
    type: MARK_AS_RMA_SET_DEVICE,
    payload: device
})